import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-search-select-field',
  standalone: true,
  imports: [SelectModule, FormsModule],
  templateUrl: './search-select-field.component.html',
  styleUrl: './search-select-field.component.scss',
})
export class SearchSelectFieldComponent {
  @Input() inputControlName!: string;
  @Input() options!: any[];
  @Input() placeholder?: string;
  @Input() selected: string = 'Importaciones';
  @Output() selectedChange = new EventEmitter<string>();

  get selectedOption(): string {
    return this.selected;
  }
  set selectedOption(v: string) {
    this.selected = v;
    this.selectedChange.emit(v);
  }
}
